export default __webpack_public_path__ + "static/ceo-name-21dad1899660ff2406a66c1ce957a87c.svg";